/**
 * Validation rules for checkout form fields
 * Each rule has a validate function and an error message
 */

/**
 * Full Name validation rules
 * - Must not be empty
 * - Must be at least 2 characters
 * - Must include a space (first and last name)
 */
export const nameRules = [
  {
    validate: (value) => value.trim().length > 0,
    message: 'Your name is required'
  },
  {
    validate: (value) => {
      const trimmed = value.trim();
      return trimmed.length >= 2 && trimmed.includes(' ');
    },
    message: 'Please enter your full name (first and last name)'
  }
];

/**
 * Email validation rules
 * - Must not be empty
 * - Must match email pattern
 */
export const emailRules = [
  {
    validate: (value) => value.trim().length > 0,
    message: 'Your email address is required'
  },
  {
    validate: (value) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value.trim());
    },
    message: 'Please enter a valid email address'
  }
];

/**
 * Phone number validation rules
 * - Must not be empty
 * - Must have at least 10 digits (excluding formatting)
 */
export const phoneRules = [
  {
    validate: (value) => value.trim().length > 0,
    message: 'Your phone number is required'
  },
  {
    validate: (value) => {
      // Extract only numeric digits
      const digits = value.replace(/\D/g, '');
      return digits.length >= 10;
    },
    message: 'Please enter a valid phone number'
  }
];
